import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { PRODUCT_IMAGE, packItems, volumes, volumesIntro } from '../data/content';
import { volumeCovers } from '../data/pages';
import { Brand } from './Brand';
export function WhatsInside() {
  const [active, setActive] = useState<number>(0);
  const volume = volumes[active];
  const cover = volumeCovers[active] ?? volume.cover;
  return <section id="inside" className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-281" data-mp="b4bqixuy6i4g">
      <div className="mx-auto max-w-6xl" data-id="element-282" data-mp="fyfzfmnrx086">
        <h2 className="mx-auto max-w-3xl text-center font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-283" data-mp="2605rcgriejx">
          <em className="text-red-700" data-id="element-284" data-mp="75mh1gd15kq3"><Brand data-id="element-285" data-mp="72qjvu90b02p" /></em> 包括甚麼？
        </h2>

        <div className="mt-16 grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-286" data-mp="3ocga2ofbfvia">
          <h3 className="font-serif text-3xl leading-tight text-slate-900 sm:text-4xl lg:col-span-6" data-id="element-287" data-mp="3tc1jjss43m99">
            {volumesIntro.title}
          </h3>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-6" data-id="element-288" data-mp="3csmhz120hddh">{volumesIntro.text}</p>
        </div>

        <div role="tablist" aria-label="分冊" className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-id="element-289" data-mp="37ukzah8hzg2j">
          {volumes.map((item, index) => {
          const isActive = index === active;
          return <button key={item.number} type="button" role="tab" id={`volume-tab-${index}`} aria-selected={isActive} aria-controls="volume-panel" onClick={() => setActive(index)} className={`flex h-56 min-w-0 flex-col rounded-lg border-r-8 border-black/10 p-4 text-left shadow-xl shadow-slate-900/20 transition-[transform,opacity] duration-200 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-red-700/40 sm:h-64 lg:h-72 ${item.spine} ${isActive ? '-translate-y-2' : 'opacity-75 hover:-translate-y-1 hover:opacity-100'}`} data-id="element-290" data-mp="3hqwcrajtqbyk" data-mpi={index}>
                <span className="text-xs font-semibold opacity-80" data-id="element-291" data-mp="26edi07ahwuxp">{item.number}</span>
                <span className="mt-1 font-serif text-2xl leading-tight sm:text-3xl" data-id="element-292" data-mp="9dhb5cqa4tnw">{item.level}</span>
                <span className={`mt-auto border-t pt-3 text-sm font-medium leading-snug ${item.rule}`} data-id="element-293" data-mp="ec0wpc0yo3fq">
                  {item.title}
                </span>
              </button>;
        })}
        </div>

        <div id="volume-panel" role="tabpanel" aria-labelledby={`volume-tab-${active}`} className="mt-8 border-t border-slate-900/15 pt-10" data-id="element-294" data-mp="o2n9kyhamfuq">
          <AnimatePresence mode="wait" initial={false} data-id="element-295" data-mp="3mlao3a1h2fws">
            <motion.div key={volume.number} initial={{
            opacity: 0,
            y: 6
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -6
          }} transition={{
            duration: 0.18,
            ease: [0.23, 1, 0.32, 1]
          }} className="grid gap-10 lg:grid-cols-12" data-id="element-296" data-mp="3riavboa25oph">
              <div className="lg:col-span-5" data-id="element-297" data-mp="1bu0zkxrz1zcj">
                <img src={cover ?? PRODUCT_IMAGE} alt={`${volume.number}：${volume.title}`} loading="lazy" className={`mb-8 block h-auto ${cover ? 'w-48 rounded-md border border-slate-900/10 shadow-xl shadow-slate-900/20 sm:w-56' : 'w-64 drop-shadow-xl sm:w-72'}`} data-id="element-298" data-mp="1gpq6jm6bmiiv" />
                <p className="text-sm font-semibold text-red-700" data-id="element-299" data-mp="2riqvntdewftt">
                  {volume.number} · {volume.level}
                </p>
                <h4 className="mt-2 font-serif text-3xl leading-tight text-slate-900 sm:text-4xl" data-id="element-300" data-mp="2mj4i1ito8xkh">{volume.title}</h4>
                <p className="mt-4 text-lg leading-relaxed text-slate-900/80" data-id="element-301" data-mp="2hme00pyb3rwf">{volume.tagline}</p>
                <p className="mt-3 leading-relaxed text-slate-900/70" data-id="element-302" data-mp="2dho97fii93id">{volume.intro}</p>
              </div>
              <div className="lg:col-span-7" data-id="element-303" data-mp="28kejrzv48ruj">
                <p className="text-sm font-semibold text-slate-900/60" data-id="element-304" data-mp="23ll5i5808wtb">內容包括</p>
                <ul className="mt-4 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-305" data-mp="6srovn83scss">
                  {volume.items.map(entry => <li key={entry} className="flex gap-3 text-[15px] leading-snug text-slate-900/80" data-id="element-306" data-mp="1totkuhxdky0">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-700" strokeWidth={2.5} aria-hidden="true" data-id="element-307" data-mp="2vlxz07j6cs7k" />
                      {entry}
                    </li>)}
                </ul>
                <p className="mt-6 font-serif text-xl italic leading-snug text-slate-900/80" data-id="element-308" data-mp="2lnh5b2supzht">{volume.outro}</p>
                {volume.note && <p className="mt-3 text-xs leading-relaxed text-slate-900/60" data-id="element-309" data-mp="2qlsedbbbo5yz">{volume.note}</p>}
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="mt-24 border-t border-slate-900/15 pt-12" data-id="element-310" data-mp="2go5nrrknupz6">
          <div className="grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-311" data-mp="2gqieat4hi8nu">
            <h3 className="font-serif text-3xl leading-tight text-slate-900 sm:text-4xl lg:col-span-6" data-id="element-312" data-mp="22yah509agfom">
              <Brand data-id="element-313" data-mp="27wlsjff8ey8y" /> 有甚麼不同？
            </h3>
            <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-6" data-id="element-314" data-mp="1syti31ojl01m">
              一整個學年的音樂教材——整理好，即刻用得着。
            </p>
          </div>
          <ul className="mt-12 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-315" data-mp="1xxefyugbn7mw">
            {packItems.map(item => {
            const Icon = item.icon;
            return <li key={item.title} data-id="element-316" data-mp="1ab15gl3mn4xp">
                  <Icon className="h-6 w-6 text-red-700" strokeWidth={1.75} aria-hidden="true" data-id="element-317" data-mp="1ac3v6pp7r1c1" />
                  <h4 className="mt-4 font-serif text-2xl leading-tight text-slate-900" data-id="element-318" data-mp="1obvbwy746vtq">{item.title}</h4>
                  <p className="mt-2 text-sm leading-relaxed text-slate-900/70" data-id="element-319" data-mp="1j9w6zjvq7quo">{item.text}</p>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}